module.exports = __webpack_public_path__ + "components/flag/static/square/cy-9dac56e14caf75b391c9891d6b888d66.svg";